import store from '@/store';

export async function responseErrorInterceptor(error: any) {
  if (error.response.status === 401) {
    await store.dispatch('logout', { id: null });
  }
  throw error;
}
